'use client'

import { HomeContainer } from '@/components/common'
import { ModalDescriptionReferFriend } from '@/components/common/refer-friend/modal-description-refer'
import { Button } from '@/components/ui/button'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'

export const ShareFriend = () => {
  const t = useTranslations()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <HomeContainer>
        <div className='rounded-2xl bg-neutral-100 px-4 py-13 lg:py-20'>
          <h3 className='text-center font-criteria text-2xl font-semibold text-neutral-900 lg:text-[55px] lg:font-medium lg:leading-13'>
            {t('landing_coolclub_page.share_friend.title')}
          </h3>
          <p className='mt-3 text-center font-sans text-base text-neutral-600 lg:text-2xl lg:leading-8'>
            {t('landing_coolclub_page.share_friend.description')}
          </p>

          <div className='mt-10 space-y-3 lg:mt-8 lg:flex lg:justify-center lg:gap-3 lg:space-y-0'>
            <Button
              variant='black'
              className='flex w-full lg:w-fit'
              onClick={() => setIsOpen(true)}
            >
              <Image
                alt='Share'
                src='/icons/icon-share-white.svg'
                width={19}
                height={21}
              />
              {t('landing_coolclub_page.share_friend.share_button')}
            </Button>
            <Button
              variant='outline-neutral'
              asChild
              className='flex w-full lg:w-fit'
            >
              <Link href='/account/refer-friend'>
                {t('landing_coolclub_page.share_friend.learn_more')}
              </Link>
            </Button>
          </div>
        </div>
        {isOpen && (
          <ModalDescriptionReferFriend
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
          />
        )}
      </HomeContainer>
      <picture className='block w-full'>
        <source
          media='(max-width: 768px)'
          srcSet={ImageHelper.getImageUrl('/image/January2025/mceclip0_51.jpg')}
        />
        <Image
          src={ImageHelper.getImageUrl('/image/January2025/mceclip1_99.jpg')}
          alt={t('landing_coolclub_page.share_friend.image_alt')}
          width={1000}
          height={1000}
          className='w-full'
        />
      </picture>
    </>
  )
}
